import { ChangeDetectionStrategy, Component, ElementRef, inject } from '@angular/core';

@Component({
  selector: 'sidebar-subnav',
  templateUrl: './subnav.component.html',
  styleUrl: './subnav.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'subnav' },
})
export class SidebarSubnavComponent {
  public readonly el = inject<ElementRef<HTMLElement>>(ElementRef);
}
